import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import usePermission from './use-permission';
import NotAllowed from './not-allowed';
import { FallbackView } from 'src/_metronic/partials';

interface ProtectedRouteProps extends RouteProps {
  permission: string;
  component: React.ComponentType<any>;
}

/**
 * ProtectedRoute - İzin kontrolü yapan Route komponenti
 *
 * Kullanım:
 * <ProtectedRoute path="/users" permission="ROLE_USERS" component={UsersPage} />
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ permission, component: Component, ...rest }) => {
  const [loading, allowed] = usePermission(permission);

  return (
    <Route
      {...rest}
      render={(props) => {
        // Loading veya henüz izin kontrolü yapılmamışsa loading göster
        if (loading || allowed === undefined) {
          return <FallbackView />;
        }

        // İzin varsa komponenti render et
        if (allowed === true) {
          return <Component {...props} />;
        }

        // İzin yoksa NotAllowed göster
        return <NotAllowed />;
      }}
    />
  );
};

export default ProtectedRoute;
